<template>
  <div class="container">
    <vue-slick-carousel v-bind="settings">
      <div class="nftcard" v-for="(nft, index) in nfts" :key="index">
        <img :src="nft.src" class="img-fluid" alt @click="openSilentBox(nft)" />
      </div>
    </vue-slick-carousel>
  </div>
</template>

<script>
import VueSlickCarousel from "vue-slick-carousel";
import "vue-slick-carousel/dist/vue-slick-carousel.css";
import "vue-slick-carousel/dist/vue-slick-carousel-theme.css";

export default {
  data() {
    return {
      settings: {
        dots: false,
        infinite: false,
        initialSlide: 0,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 1,
        swipeToSlide: false,
        responsive: [
          { breakpoint: 992, settings: { slidesToShow: 2 } },
          { breakpoint: 576, settings: { slidesToShow: 1 } },
        ],
      },
      nfts: [
        { src: "/assets/images/nft/f01.webp" },
        { src: "/assets/images/nft/f02.webp" },
        { src: "/assets/images/nft/f03.webp" },
        { src: "/assets/images/nft/f04.webp" },
        { src: "/assets/images/nft/m01.webp" },
        { src: "/assets/images/nft/m02.webp" },
        { src: "/assets/images/nft/m03.webp" },
        { src: "/assets/images/nft/m04.webp" },
        { src: "/assets/images/nft/m05.webp" },
        { src: "/assets/images/nft/m06.webp" },
        { src: "/assets/images/nft/m07.webp" },
        { src: "/assets/images/nft/m08.webp" },
        { src: "/assets/images/nft/m09.webp" },
        { src: "/assets/images/nft/m10.webp" },
        { src: "/assets/images/nft/m11.webp" },
        { src: "/assets/images/nft/m12.webp" },
        { src: "/assets/images/nft/m13.webp" },
        { src: "/assets/images/nft/m14.webp" },
        { src: "/assets/images/nft/m15.webp" },
        { src: "/assets/images/nft/m16.webp" },
        { src: "/assets/images/nft/m17.webp" },
        { src: "/assets/images/nft/m18.webp" },
        { src: "/assets/images/nft/m19.webp" },
      ],
    };
  },
  mounted() {
    this.nfts.sort(() => Math.random() - 0.5);
  },
  methods: {
    openSilentBox(item) {
      if (this.$device.mobile) return;

      this.$silentbox.open(item);
    },
  },
  components: {
    VueSlickCarousel,
  },
};
</script>

<style lang="scss" scoped>
.nftcard {
  padding: 1.25rem;
  transition: padding 0.3s ease;
  @media (min-width: 767.98px) {
    cursor: pointer;
  }
  img {
    box-shadow: 0 0 2px #fff8;
  }
  &:hover {
    @media (min-width: 768px) {
      padding: 1rem;
      -webkit-filter: drop-shadow(0px 0px 0.5rem #ffeca6);
      filter: drop-shadow(0px 0px 0.5rem #ffeca6);
    }
  }
}
</style>
